import * as styles from '../../styles/components/DashboardTarget.less';
import React from 'react';
import { TARGET_URL } from '../../constants/config';

interface DashboardTargetItem {
  _id: string;
  name: string;
  level: number;
}

interface DashboardTargetProps {
  target: DashboardTargetItem;
  // A boolean, NOT the selectedTargets array. Passing the array defeated the
  // React.memo below — its identity changes on every toggle, so every row in the
  // list re-rendered and each one re-scanned the array with .includes(), making
  // a single click O(n²) in the number of targets.
  isSelected: boolean;
  onTargetToggle: (id: string) => void;
}

const DashboardTarget = ({ target, isSelected, onTargetToggle }: DashboardTargetProps) => {
  const _onTargetToggle = () => onTargetToggle(target._id);
  return (
    <div style={{paddingLeft: target.level + 'em'}}>
      <label className={styles.label}>
        <input
          className={styles.checkbox}
          type="checkbox"
          checked={isSelected}
          onChange={_onTargetToggle} />
        <span>
          <i className="fa fa-square"></i>
          <i className="fa fa-check-square"></i>
        </span>
        {target.name}
      </label>
      <a className={styles['target--link']}
        href={`${TARGET_URL}/${target._id}`}
        title="Open target"
        target="_blank"><i className="fa fa-lg fa-external-link" aria-hidden="true"></i></a>
    </div>
  );
};

export default React.memo(DashboardTarget);
